import './App.css';
import IndexInformation from './container/IndexInformation';


function App() {
  return (
    <div className="App">
      <IndexInformation/>
    </div>
  );
}

export default App;
